import axios from 'axios';
import { ApplicationOfflineInterceptor } from '../application/components/application-offline';
const request = axios.create({
    baseURL: process.env.API_BASE_URL
});
request.interceptors.response.use(undefined, ApplicationOfflineInterceptor);
export default request;
